import { Component } from "../../scripts/component";
import { ThemeEvents } from './events';


class BackInStock extends Component {
  #abortController = new AbortController();
  
  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#abortController;

    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
    
    this.onFormSubmit();
  }

  #onVariantUpdate = (event) => {
    if (!event.detail.resource) {
      console.warn('No resource found');
      return;
    }
    const variantId = event.detail.resource?.id;
    if (variantId) this.dataset.variantId = variantId;
    
    const available = event.detail.resource ? event.detail.resource.available : null;
    if (available) {
      this.section?.querySelector('#back-in-stock')?.classList.add('hidden');
      this.section?.querySelector('#add-to-cart-wrapper')?.classList.remove('hidden');
    } else {
      this.section?.querySelector('#back-in-stock')?.classList.remove('hidden');
      this.section?.querySelector('#add-to-cart-wrapper')?.classList.add('hidden');
    }
    
  }

  onFormSubmit() {
    this.form = this.querySelector('form');
    if (!this.form) {
      console.warn('No form found');
      return;
    }

    this.form.addEventListener('submit', (evt) => {
      evt.preventDefault();
      this.submitForm();
    });
  }

  async submitForm() {
    if (!this.form) {
      console.warn('No form found');
      return;
    }

    const variantId = this.dataset.variantId;
    if (!variantId) {
      console.warn('No variant id found');
      return;
    }

    const successAnswer = this.querySelector('.form-success');
    const errorAnswer = this.querySelector('.form-error');
    if (!successAnswer || !errorAnswer) {
      console.warn('No success or error answer found');
      return;
    }

    const email = this.form.querySelector('input[name="email"]')?.value;
    const newsletter = this.form.querySelector('input[name="newsletter"]')?.checked;

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2025-10-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`
              }
            }
          }
        },
      }),
    };
    
    try {
      const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=XhVNP4', options);
      if (response.ok) {
        const listId = 'ScNcQQ';
        console.log('✅ Back in stock event sent successfully');
        if (newsletter) await this.subscribeToList(listId, email);
        this.form.classList.add('hidden');
        successAnswer.classList.remove('hidden');
      } else {
        console.log('❌ Back in stock event sent failed');
        this.form.classList.add('hidden');
        errorAnswer.classList.remove('hidden');
      }
    } catch (error) {
      console.error(error);
      this.form.classList.add('hidden');
      errorAnswer.classList.remove('hidden');
    }
  }

  async subscribeToList(listId, email) {
    try {
      await fetch(`https://netlify.blacklemon.dk/.netlify/functions/subscribeProfileToList?listId=${listId}&email=${email}&store=rezet`);
      console.log('✅ Subscribed to list successfully');
    } catch (error) {
      console.error(error);
    }
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock);
}